import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box, Hidden, Button, FormControl, Select, MenuItem } from '@material-ui/core'
import { styled } from '@material-ui/core/styles';

import Moment from 'moment'
import 'moment/locale/fr';

import APIS from "../../../utils/APIS"

import SelectEcoleMenuMobile from "./SelectEcoleMenuMobile"
import CompletionChart from './CompletionChart'
import SoftSkillsViewer from './SoftSkillsViewer'
import BlockModal from "./BlockModal"
import MyModal from "../../ui/MyModal"

import UserAdminClientContext from "../../../contexts/UserAdminClientContext"
import LanguageContext from "../../../contexts/LanguageContext"

import folderIcon from "../../../images/folderIcon.svg"
import simpleArrowIcon from "../../../images/simpleArrowIcon.svg"
import cardIcon from "../../../images/cardIcon.svg"
import lockedIcon from "../../../images/lockedIcon.svg"
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import fakeVideoTuto from "../../../images/fakeVideoTuto.png"

Moment.locale('fr')

export const ModalTuto = ({isOpen, onClose, title, subTitle, videoUrl}) => {
  const { actLanguage, languageValues } = useContext(LanguageContext)

  return (
    <MyModal
      isOpen={isOpen}
      maxWidth="md"
      onClose={onClose}
      title={title}
      subTitle={subTitle}
    >
      <Box sx={{
        display:"flex",
        flexDirection:"column",
        flex:1,
        justifyContent:["space-between", "unset"],
        gap:"10px",
      }}>
        <Box sx={{
          display:"flex",
          flexDirection:"column",
          gap:"10px"
        }}>
          <Box sx={{
            width:"100%",
            aspectRatio:"16/9",
            background:"#FAF8F6",
            backgroundRepeat:"no-repeat",
            backgroundImage:`url(${fakeVideoTuto})`,
            backgroundSize:"cover"
          }}>
          </Box>
        </Box>
        <Hidden smUp>
          <Box sx={{
            paddingTop:["0px", "30px"]
          }}>
            <Button
              color="primary"
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              onClick={onClose}
            >
              {languageValues?.close[actLanguage]}
            </Button>
          </Box>
        </Hidden>
      </Box>
    </MyModal>
  )
}


const Home = ({ }) => {

  const {
    ecoles,
    actEcole,
    actEcoleID,
    currentUser,
    updateActEcole,
  } = useContext(UserAdminClientContext)

  const { actLanguage, languageValues } = useContext(LanguageContext)

  const [seeTuto, setSeeTuto] = useState(false)
  const [lockedModal, setLockedModal] = useState(false)

  const [subGroup, setSubGroup] = useState(null)
  const [dataLoaded, setDataLoaded] = useState(false)
  const [completion, setCompletion] = useState([])
  const [softSkills, setSoftSkills] = useState([])

  useEffect(() => {
    if (actEcole?.groupes?.length > 0) {
      setSubGroup(actEcole?.groupes[0])
    } else {
      setSubGroup(null)
    }
  }, [actEcole])

  useEffect(() => {
    setDataLoaded(false)
    if (subGroup) {
      let ids = []
      if (subGroup?.icebreaker) {
        ids.push(subGroup?.icebreaker)
      }
      subGroup.plan.plan.forEach((p) => {
        ids.push(p.id)
      })
      APIS.completionAndSoftSkills({groupeID : subGroup.groupeID, ids : ids}).then((result) => {
        if (result.isOk === true && result.softSkills) {
          setSoftSkills(result.softSkills)
          if (result.completion) {
            setCompletion(result.completion)
          } else {
            setCompletion([])
          }
          setDataLoaded(true)
        } else {
          setDataLoaded(false)
        }
      })
    }
  }, [subGroup])

  return (
    <>
      <Hidden smUp>
        <SelectEcoleMenuMobile />
      </Hidden>

      <BlockModal
        open={lockedModal !== false ? true : false}
        onClose={() => { setLockedModal(false) }}
        type={lockedModal}
      />

      <ModalTuto
        isOpen={seeTuto}
        onClose={() => {
          setSeeTuto(false)
        }}
        title={languageValues?.adminDashboard?.homePage?.tutoTitle[actLanguage]}
        subTitle={languageValues?.adminDashboard?.homePage?.tutoSubTitle[actLanguage]}
        videoUrl={null}
      />


      <Box
        sx={{
          flex:1,
          padding:["20px", "50px", "50px", "80px"],
          backgroundColor:"background.grey",
        }}
      >
        {/* TOP */}
        <Box sx={{
          display:"flex",
          flexDirection:["column", "row"],
          justifyContent:"space-between",
          paddingBottom:["30px","40px","40px","50px"],
          rowGap:"15px",
          columnGap:"30px",
          alignItems:["flex-start","center"],
          overflow:"hidden",
        }}>
          <Box sx={{
            overflow:"hidden",
            maxWidth:"100%"
          }}>
            <Box sx={{
              fontSize:["14px","16px","16px","16px"],
              color:"text.blackTitle",
              display:"flex",
              alignItems:"center",
              gap:"8px",
              textTransform:"capitalize",
            }}>
              <Box sx={{
                width:["0px", "20px", "24px"],
                display:["none", "block"]
              }}>
                <img src={folderIcon} style={{width:"100%"}}/>
              </Box>
              {actEcole?.name}
            </Box>
            <Box sx={{
              fontSize:["26px","36px","36px","42px"],
              color:"text.black",
              paddingTop:["10px", "12px", "12px", "15px"],
              paddingBottom:["10px", "12px", "12px", "15px"],
              whiteSpace:"nowrap",
              overflow:"hidden",
              textOverflow:"ellipsis",
            }}>
              {languageValues?.adminDashboard?.homeWelcome[actLanguage]}{currentUser?.name?.split(" ")[0]},
            </Box>
            <Box sx={{
              fontSize:["15px","19px","19px","22px"],
              color:"text.black",
              whiteSpace:"nowrap",
              overflow:"hidden",
              textOverflow:"ellipsis",
            }}>
              {languageValues?.adminDashboard?.homeWelcomeSub[actLanguage]}
            </Box>
          </Box>
          <Box sx={{
            display:"flex",
            flexDirection:["row", "column"],
            rowGap:"15px",
            columnGap:"15px",
            overflow:"hidden",
            maxWidth:"100%",
          }}>
            <Box sx={{
              order:[1, 0, 0, 0],
              display:"flex",
              flexDirection:"column",
              justifyContent:"center",
              gap:"5px"
            }}>
              <Box sx={{
                color:"text.blackTitle",
                fontSize:["12px","13px","13px","14px"],
                textAlign:["left", "right"],
                whiteSpace:"nowrap",
                overflow:"hidden",
                textOverflow:"ellipsis",
              }}>
                {actLanguage === "fr" ? (
                  <>
                    {Moment().locale('fr').format('LL')}
                  </>
                ) : (
                  <>
                    {Moment().locale('en').format('LL')}
                  </>
                )}
              </Box>
              <Box sx={{
                color:"text.blackTitle",
                fontSize:["15px","16px","16px","18px"],
                textAlign:["left", "right"],
                whiteSpace:"nowrap",
                overflow:"hidden",
                textOverflow:"ellipsis",
              }}>
                {currentUser?.poste}
              </Box>
            </Box>
            <Box>
              <Button
                onClick={() => { setSeeTuto(true) }}
                size="large"
                type="submit"
                variant="contained"
                sx={{
                  height:["45px !important", "45px !important", "45px !important", "50px !important"],
                  minHeight:["45px !important", "45px !important", "45px !important", "50px !important"],
                  fontSize:["14px", "14px", "15px", "16px"],
                  whiteSpace:"nowrap"
                }}
              >
                {languageValues?.adminDashboard?.seeTuto[actLanguage]}
              </Button>
            </Box>
          </Box>
        </Box>
        {/* END TOP */}

        {/* CARDS */}
        <Box sx={{
          paddingBottom:["25px","30px","30px","40px"],
          display:"flex",
          flexDirection:["column","row"],
          columnGap:["20px","20px","20px","30px"],
          rowGap:"15px",
        }}>
          <Card
            locked={false}
            title={languageValues?.adminDashboard?.monitoring[actLanguage]}
            subTitle={languageValues?.adminDashboard?.homePage?.monitoringSub[actLanguage]}
            onClick={() => { updateActEcole(actEcole?.ecoleID, "suivi") }}
            onClickLocked={() => { }}
          />
          <Card
            locked={currentUser?.plan?.mapping === true ? false : true}
            title={languageValues?.adminDashboard?.mapping[actLanguage]}
            subTitle={languageValues?.adminDashboard?.homePage?.mappingSub[actLanguage]}
            onClick={() => { updateActEcole(actEcole?.ecoleID, "progression") }}
            onClickLocked={() => {
              setLockedModal("mapping")
            }}
          />
          <Card
            locked={currentUser?.plan?.certif === true ? false : true}
            title={languageValues?.adminDashboard?.certification[actLanguage]}
            subTitle={languageValues?.adminDashboard?.homePage?.certificationSub[actLanguage]}
            onClick={() => { updateActEcole(actEcole?.ecoleID, "certification") }}
            onClickLocked={() => {
              setLockedModal("certification")
            }}
          />
        </Box>
        {/* END CARDS */}

        { /* GROUP SELECT */}
        {actEcole?.groupes?.length > 0 &&
          <Box sx={{
            paddingBottom:["25px","30px","30px","40px"],
          }}>
            <FormControl>
              <Select
                IconComponent = {KeyboardArrowDownIcon}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      width:["200px","200px","200px","250px"],
                      background: 'white',
                      borderRadius:"0 !important",
                      border:"1px solid black",
                      overflow:"hidden",
                      '& .MuiList-root': {
                        padding: 0,
                        overflow:"hidden",
                      },
                      '& .MuiMenuItem-root': {
                        padding: 2,
                        overflow:"hidden"
                      },
                    },
                  },
                }}
                sx={{
                  width:["200px","200px","200px","250px"],
                  height:["40px !important","50px !important"],
                  color:"text.black",
                  fontSize:["16px","18px","18px","20px"],
                  borderRadius:"0px",
                  background:"transparent",
                  border:0,
                  borderBottom:"2px solid black",
                  "& .MuiSelect-icon": {
                    width:["20px","26px","26px","30px"],
                    height: ["20px","26px","26px","30px"],
                    right : "0px",
                    top : ["calc(50% - 10px)","calc(50% - 13px)","calc(50% - 13px)","calc(50% - 15px)"],
                    color:"text.black",
                  },
                  "& fieldset": {
                    border:0,
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border:0,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    border:0,
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border:0,
                  },
                }}
                value={subGroup?.groupeID || ""}
                onChange={(e) => {
                  let find = actEcole?.groupes?.find((el) => el.groupeID === e.target.value)
                  if (find) {
                    setSubGroup(find)
                  }
                }}
              >
                {actEcole?.groupes?.map((g, index) => {
                  let text = g.diplome
                  if (text === null || text === "") {
                    text = g.name
                  }
                  return (
                    <MenuItem key={g.groupeID} value={g.groupeID}>
                      <Box sx={{
                        overflow:"hidden",
                        whiteSpace:"noWrap",
                        textOverflow:"ellipsis",
                      }}>
                        {text}
                      </Box>
                    </MenuItem>
                  )
                })}
              </Select>
            </FormControl>
          </Box>
        }
        { /* END GROUP SELECT */}

        { /* GRAPHS */ }
        <Box sx={{
          paddingBottom:["25px","30px","30px","40px"],
          display:"flex",
          flexDirection:["column","column","column","row"],
          columnGap:"50px",
          rowGap:"25px",
        }}>
          <Box sx={{
            background:"white",
            border:"1px solid #E7E7E7",
            flex:1,
            width:["100%","100%","100%","50%"],
            padding:["20px", "25px", "30px", "30px"],
            height:["100vw", "450px", "45vw", "25vw"],
            minHeight:["100vw", "450px", "45vw", "25vw"],
            maxHeight:["100vw", "450px", "45vw", "25vw"],
            overflow:"hidden",
            display:"flex",
          }}>
            <CompletionChart dataLoaded={dataLoaded} subGroup={subGroup} completion={completion} plan={subGroup?.plan?.plan}/>
          </Box>
          <Box sx={{
            background:"white",
            border:"1px solid #E7E7E7",
            flex:1,
            width:["100%","100%","100%","50%"],
            padding:["20px", "25px", "30px", "30px"],
            paddingBottom:["10px", "15px", "20px", "20px"],
            height:["unset", "450px", "45vw", "25vw"],
            minHeight:["unset", "450px", "45vw", "25vw"],
            maxHeight:["unset", "450px", "45vw", "25vw"],
            display:"flex",
            flexDirection:"column",
            overflow:"hidden",
          }}>
            <SoftSkillsViewer dataLoaded={dataLoaded} softSkills={softSkills}/>
          </Box>
        </Box>
        { /* END GRAPHS */ }

      </Box>

    </>
  )
}

const Card = ({ locked, title, subTitle, onClick, onClickLocked }) => {
  return (
    <Box onClick={locked ? onClickLocked : onClick} sx={{
      flex:1,
      backgroundColor:locked ? "rgba(255,255,255,0.5)" : "white",
      border:locked ? "1px dashed #E7E7E7" : "1px solid #E7E7E7",
      height:["110px", "170px", "170px", "215px"],
      minHeight:["110px", "170px", "170px", "215px"],
      cursor:"pointer",
      padding:["20px","20px","20px","25px"],
      display:"flex",
      flexDirection:["row", "column"],
      justifyContent:["flex-start", "center"],
      userSelect:"none",
      "&:hover" : {
        border:locked ? "1px dashed black" : "1px solid black",
      }
    }}>
      <Hidden smDown>
        <Box sx={{
          display:"flex",
          justifyContent:"space-between",
          alignItems:"center",
        }}>
          <Box sx={{
            width:["40px", "40px", "40px", "55px"],
          }}>
            <img src={cardIcon} style={{width:"100%"}}/>
          </Box>
          {!locked &&
            <Box sx={{
              width:["15px", "15px", "15px", "25px"],
            }}>
              <img src={simpleArrowIcon} style={{width:"100%"}}/>
            </Box>
          }
        </Box>
        <Box sx={{
          display:"flex",
          alignItems:"center",
          gap:"10px",
          paddingTop:"15px",
          paddingBottom:"10px",
        }}>
          <Box sx={{
            color:"text.black",
            fontSize:["23px", "23px", "23px", "32px"]
          }}>
            {title}
          </Box>
          {locked &&
            <Box sx={{
              width:["14px", "14px", "14px", "19px"],
            }}>
              <img src={lockedIcon} style={{width:"100%"}}/>
            </Box>
          }
        </Box>
        <Box sx={{
          color:"text.black",
          fontSize:["14px", "14px", "14px", "18px"]
        }}>
          {subTitle}
        </Box>
      </Hidden>
      <Hidden smUp>
        <Box sx={{
          marginRight:"10px"
        }}>
          <img src={cardIcon} style={{width:"40px"}}/>
        </Box>
        <Box sx={{
          display:"flex",
          flexDirection:"column",
          justifyContent:"space-evenly",
          gap:"7px",
        }}>
          <Box sx={{
            display:"flex",
            gap:"8px",
            alignItems:"center",
          }}>
            <Box sx={{
              color:"text.black",
              fontSize:["20px"]
            }}>
              {title}
            </Box>
            {locked &&
              <img src={lockedIcon} style={{width:"13px"}}/>
            }
            {!locked &&
              <img src={simpleArrowIcon} style={{width:"15px"}}/>
            }
          </Box>
          <Box sx={{
            color:"text.black",
            fontSize:"13px",
          }}>
            {subTitle}
          </Box>
        </Box>
      </Hidden>
    </Box>
  )
}


export default Home
